import state from "./state";
import mutations from "./mutations";
import actions from "./actions";

const solicitudStore = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default solicitudStore;
